/**
 * Shows a video
 */
import React from 'react';
import PropTypes from 'prop-types';
import VideoComponent from '../../../components/video/VideoComponent';
import clone from 'lodash/clone';

class VideoView extends React.Component {
    static propTypes = {
        profileId: PropTypes.number.isRequired,
        video: PropTypes.object.isRequired,
        onRemove: PropTypes.func.isRequired,
        onUpdate: PropTypes.func.isRequired,
        mode: PropTypes.string,
    };

    onRemove = (evt) => {
        evt.preventDefault();
        this.props.onRemove(this.props.profileId, this.props.video.id);
    };

    onDescriptionChange = (description) => {
        const updatedVideo = clone(this.props.video);
        updatedVideo.description = description;
        this.props.onUpdate(this.props.profileId, updatedVideo);
    };

    render() {
        return (
            <div className="panel">
                <VideoComponent
                    description={this.props.video.description}
                    dimensions={{ h: 252, w: 448 }}
                    onSubmit={this.onDescriptionChange}
                    videoUrl={this.props.video.href}
                >
                    <span className="u-float-right">
                        <button
                            className="button button--destructive-flat"
                            onClick={this.onRemove}
                            type="button"
                        >
                            Slett video
                        </button>
                    </span>
                </VideoComponent>
            </div>
        );
    }
}

export default VideoView;
